import loades from '../assets/images/l.gif'
const LoaderDate = () => {
    return ( <div className="loadingdata">

        <img src={loades} alt="" />
    </div> );
}
 
export default LoaderDate;